import { render, staticRenderFns } from "./FilmMain.vue?vue&type=template&id=17d8d782&scoped=true"
import script from "./FilmMain.vue?vue&type=script&lang=js"
export * from "./FilmMain.vue?vue&type=script&lang=js"
import style0 from "./FilmMain.vue?vue&type=style&index=0&id=17d8d782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d8d782",
  null
  
)

export default component.exports